import React from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { connect } from 'react-redux';
import { REDUCER_NAME, setFilterCondition } from '../../reducer';
import Const from '../../Const';
import './source-span.scss';
import { I18n } from 'react-redux-i18n';

const KEY_VALUE = {
  1: Const.NewsAggregatorTable.SOURCE,
  2: 'sourceCode',
  3: null,
  4: {
    1: Const.MostRecentTable.CONTRIBUTOR,
    2: Const.MostPopularTable.CONTRIBUTOR,
    3: '',
    4: '',
  },
};

const SOURCE_COLOR = {
  High: 'bg-s-color-3',
  Medium: 'bg-s-color-4',
  Low: 'bg-l-color-3',
};

class SourceSpan extends React.Component {
  constructor(props) {
    super(props);
    const { currentFilterCondition, code } = this.props;
    if (currentFilterCondition) {
      const flag = Object.keys(currentFilterCondition).length;
      const selectAll = !flag;
      this.initialState = {
        isShowPopup: false,
        listCheckBox: [
          {
            code,
            id: 1,
            title: 'SORT TAG',
            name: props.text,
            checked: flag,
          },
          {
            id: 2,
            title: 'SHOW ALL',
            name: 'getAll',
            checked: selectAll,
          },
        ],
      };
      this.state = this.initialState;
    } else {
      this.state = {
        isShowPopup: false,
        listCheckBox: [],
      };
    }
  }

  setCheckboxStatus = () => {
    const { text, currentFilterCondition, code } = this.props;
    if (!currentFilterCondition) return;
    const selectOne = [
      {
        code,
        id: 1,
        title: 'SORT TAG',
        name: text,
        checked: true,
      },
      {
        id: 2,
        title: 'SHOW ALL',
        name: 'getAll',
        checked: false,
      },
    ];
    const selectAll = [
      {
        code,
        id: 1,
        title: 'SORT TAG',
        name: text,
        checked: false,
      },
      {
        id: 2,
        title: 'SHOW ALL',
        name: 'getAll',
        checked: true,
      },
    ];
    const newState = {
      listCheckBox:
        currentFilterCondition && Object.keys(currentFilterCondition).length
          ? selectAll
          : selectOne,
    };
    this.setState({ ...newState }, () => this.toggleShowPopup(false));
  };

  toggleShowPopup = isShowPopup => {
    if (this.state.isShowPopup !== isShowPopup) {
      this.setState({ isShowPopup });
    }
  };

  handleClickOutside = () => {
    if (this.state.isShowPopup) {
      this.toggleShowPopup(false);
    }
  };

  handleFilter = (key, value) => {
    const { setFilterCondition, currentTab, currentChildTab } = this.props;
    setFilterCondition(
      { parentTab: currentTab, childTab: currentChildTab },
      { key, value },
    );
  };

  componentWillReceiveProps(nextProps) {
    const { storeName, currentFilterCondition, text, code } = this.props;

    if (!storeName) return;
    if (
      currentFilterCondition &&
      !Object.keys(currentFilterCondition).length &&
      Object.keys(nextProps.currentFilterCondition).length
    ) {
      this.setCheckboxStatus(nextProps.currentFilterCondition);
    } else {
      this.setState(
        {
          listCheckBox: [
            {
              code,
              id: 1,
              title: 'SORT TAG',
              name: text,
              checked: false,
            },
            {
              id: 2,
              title: 'SHOW ALL',
              name: 'getAll',
              checked: true,
            },
          ],
        },
        () => this.toggleShowPopup(false),
      );
    }
  }

  handleClickCheckBox = index => {
    const { currentTab, currentChildTab } = this.props;
    const listCheckBoxUpdated = [...this.state.listCheckBox];
    const item = listCheckBoxUpdated[index - 1];
    const key =
      currentTab !== 4
        ? KEY_VALUE[currentTab]
        : KEY_VALUE[currentTab][currentChildTab];
    const value = index - 1 === 0 ? item.code || item.name : null;
    this.handleFilter(key, value);
  };

  render() {
    const { text, type = '' } = this.props;
    const optionalClassName = SOURCE_COLOR[text];
    const { isShowPopup, listCheckBox } = this.state;
    const classNamePopup = isShowPopup ? 'dropdown-menu show' : 'dropdown-menu';
    return (
      <div className="group-action-ticker d-flex justify-content-center">
        <div className="item-btn h-100" style={{ opacity: 'unset' }}>
          <div className="dropdown h-100 d-flex align-items-start">
            <span
              className={`btn-label-cus text-center text-custom-color ${optionalClassName}`}
              style={{
                cursor: 'pointer',
                width: 100,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                margin: '4px 0',
              }}
              onClick={() => this.toggleShowPopup(true)}
              aria-haspopup="true"
              aria-expanded="false"
              title={text}
            >
              {!(type !== 'pa' && type !== 'r')
                ? I18n.t(`newsAndAnalysis.listTrustability.${text}`)
                : text}
            </span>
            {type !== 'pa' && type !== 'r' && (
              <>
                <div
                  className={classNamePopup}
                  aria-labelledby="dropdownMenuButton"
                  style={{
                    position: 'absolute',
                    transform: 'translate3d(5px, 15px, 0px)',
                    background: '#232931',
                    top: '-53px',
                    left: '-100px',
                    willChange: 'transform',
                    cursor: 'pointer',
                    minWidth: 90,
                    border: 'solid 0.5px #555555',
                  }}
                >
                  <div className="list-check">
                    {listCheckBox &&
                      listCheckBox.map((item, index) => (
                        <div key={`checkbox-${index}`} className="checkbox">
                          <input
                            checked={item.checked}
                            onChange={() => {
                              if (item.checked) return;
                              this.handleClickCheckBox(item.id);
                            }}
                            id={`checkbox-${index}`}
                            type="checkbox"
                            style={{ cursor: 'pointer' }}
                          />
                          <label
                            htmlFor={`checkbox-${index}`}
                            style={{ cursor: 'pointer' }}
                          >
                            {item.title}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { storeName } = props;

  const optionState = {};
  if (storeName) {
    optionState.currentFilterCondition =
      state[REDUCER_NAME][storeName].filterCondition;
  }

  return {
    i18n: state.i18n,
    currentTab: state[REDUCER_NAME].currentTab,
    currentChildTab: state[REDUCER_NAME].currentChildTab,
    ...optionState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setFilterCondition: (tabType, tabNumber) =>
      dispatch(setFilterCondition(tabType, tabNumber)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(enhanceWithClickOutside(SourceSpan));
